import { app } from "../constants/firebase_credentials";

import { getCountFromServer,  collection, query, startAfter, orderBy, limit, getDocs, getFirestore, doc, getDoc } from "firebase/firestore";

import { getUrlLanguage } from "./languageFunctions";


// - - - - - - Inicializar Firestore - - - - - - 
const db = getFirestore(app);


// Get the name of the collection according the language of website
function getCollectionNameLanguage(){ 

    let collectionName = "";

    if(getUrlLanguage() === "/es"){
        collectionName = 'comic_spanish';
    }else{
        collectionName = 'comic_english';
    }

    return collectionName;
}


// Calculate the number of comics there are in collection
export async function getNumberComics(){

    let comicCollection = getCollectionNameLanguage();

    const snapshot = await getCountFromServer(collection(db, comicCollection));
    return snapshot.data().count;
}

// Get only one specific comic
export async function getComic(id) {

  let comicCollection = getCollectionNameLanguage();

  // Query the one comic that will be loaded
  const comicRef = doc(db, comicCollection, id);
  const comicSnapshot = await getDoc(comicRef);
  return comicSnapshot.data();
}

export async function fetchInitialSnapshot(numComics){

    let comicCollection = getCollectionNameLanguage();

    // Query the first page of docs (user specify the limit of comics they want to load)
    let first = query(collection(db, comicCollection), orderBy('createdAt', 'desc'), limit(numComics));
    let documentSnapshots = await getDocs(first);

    return documentSnapshots; 
}

export async function fetchNextSnapshot(currentSnapshot, numComics){
    
    let comicCollection = getCollectionNameLanguage();

    // Query the next page of docs (user specify the limit of comics they want to load)
    let next = query(collection(db, comicCollection),orderBy('createdAt', 'desc'), startAfter(currentSnapshot.docs[currentSnapshot.docs.length-1]), limit(numComics));
    let documentSnapshots = await getDocs(next);

    // Check if there's an document in future page
    return documentSnapshots;
}